import cn from 'classnames'
import { tr } from 'mmfintech-commons'
import GooglePlayIcon from '@images/icons/googleplay-app-icon.svg?react'
import settings from '@settings'
import { Link } from 'react-router-dom'

import styles from './downloadAppButtons.module.scss'

export const GooglePlayButton = () => {
  return (
    <div
      className={cn(styles['download-app-link'], 'download-app-link')}
      data-coming-soon={tr('FRONTEND.DOWNLOAD_APP.COMING_SOON', 'Coming soon')}
    >
      <Link to={{ pathname: settings.googlePlayUrl }} target='_blank' data-test='download-app-googlePlay'>
        <GooglePlayIcon data-test='download-app-googleplay-icon' />
      </Link>
    </div>
  )
}
